export async function hasVisibleWorkspace(database, workspaceId) {
  if (!workspaceId) return false;

  const normalizedWorkspaceId = String(workspaceId);
  if (await database.workspaces.get(normalizedWorkspaceId)) return true;

  const directMessage = await database.direct_messages.where('workspace_id').equals(normalizedWorkspaceId).first();
  return Boolean(directMessage && directMessage.visible !== false);
}
